import { LogReport } from "../../types/logReport";
import Api from "../api";

export default async function apiGetLogReport(id: string) {
  return await Api.get<LogReport>({
    input: `/api/v1/log-report/${id}`,
  });
}
